import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment.development';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _http = inject(HttpClient);
  private _router = inject(Router);
  private _localStorageService = inject(LocalStorageService);

  private baseUrl: string = environment.apiUrl;

  constructor() { }

  verifyToken(token: string) {
    return this._http.get<any>(`${environment.apiUrl}/administrative/authentication/profile/`, { headers: { Authorization: `Bearer ${token}` } });
  }

  login(email: string, password: string) {
    const loginData = {
      username: email,
      password
    }

    return this._http.post<any>(`${this.baseUrl}/customers/authentication/login/`, loginData);
  }

  logout() {
    this._localStorageService.clear();
    this._router.navigateByUrl('/login')
  }
}
